import React from 'react'

import { PageLayout } from '@components/common'
import { Skeleton } from '@fourthwall/components'

export const TierSkeleton = () => (
  <PageLayout
    rightContent={
      <Skeleton>
        <Skeleton.Shape width="100%" height={95} />
      </Skeleton>
    }
    leftContent={
      <Skeleton gap={16}>
        <Skeleton.Shape width={110} height={28} />
        <Skeleton.Shape width="100%" height={54} />
        <Skeleton.Shape width="100%" height={78} />
        <Skeleton.Shape width="100%" height={100} />
      </Skeleton>
    }
  >
    <div style={{ marginBottom: 32 }}>
      <Skeleton gap={14}>
        <Skeleton.Shape width={150} height={24} />
        <Skeleton.Shape width={300} height={45} />
      </Skeleton>
    </div>
  </PageLayout>
)
